import { useEffect, useState, useContext } from 'react';
import * as todoServices from '../services/todoServices';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/authContext';
const useFilter = () => {
    const [err, setErrors] = useState(null);
    const [todos, setTodos] = useState([]);
    const [loading, setLoading] = useState('');
    const [filter, setFilter] = useState('');
    const { token } = useContext(AuthContext);
    const navigate = useNavigate();

    // Call when filter is changed
    useEffect(() => {
        if (!token) {
            setTodos([]);
            setLoading(false); 
            return;
        }

        setLoading(true);
        let isMounted = true; 
        const timeoutId = setTimeout(() => {
            todoServices
                .getAllTodos(filter.toLowerCase())
                .then((data) => {
                    if (isMounted) {
                        setTodos(data);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    if (isMounted) {
                        setErrors(err.message);
                        setLoading(false);
                        navigate('/login');
                    }
                });
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
            isMounted = false;
        };
    }, [filter, token, navigate]);


    return { loading, todos, filter, err, setFilter, setTodos };
};

export default useFilter;
